import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyASc40QbB61FyXhsUk1m2evIUVsADd90IE",
  authDomain: "instagram-clone-f508e.firebaseapp.com",
  databaseURL: "https://instagram-clone-f508e.firebaseio.com",
  projectId: "instagram-clone-f508e",
  storageBucket: "instagram-clone-f508e.appspot.com",
  messagingSenderId: "201176391553",
  appId: "1:201176391553:web:8ed820b3ecef3cc4d3d280",
  measurementId: "G-865RXLWZW4",
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { db, auth, storage };
